import { PropsWithChildren, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { LOGIN_ROUTE, SIGN_IN_WITH_OTP_ROUTE } from "../../../constants/routes"
import { useAppSelector } from "../../store/storeHooks"
import { LoginStatus } from "../../login/loginTypes"
import { selectLoginStatus } from "../../login/loginSelectors"
import { IntercomProvider } from "../../../shared/Intercom/IntercomProvider"
import { EnvironmentVariable } from "../../environment/envTypes"
import { getEnvVariable } from "../../../lib/getEnvVariable"
import { Logger } from "../../../lib/logging"

const cleanUrl = (url: string): string => {
    return url.replace(/[?&](token|otp)=[^&]*/g, "").replace(/\?$/, "")
}

export const Authenticated = ({ children }: PropsWithChildren) => {
    const logger = new Logger("authenticated")
    const navigate = useNavigate()
    const location = useLocation()
    const loginStatus = useAppSelector(selectLoginStatus)

    useEffect(() => {
        if (loginStatus !== LoginStatus.AUTHENTICATING) return

        const urlParams = new URLSearchParams(location.search)
        const oneTimeToken = urlParams.get("token") || urlParams.get("otp")

        if (oneTimeToken) {
            logger.info("Authenticated path but user not logged in [otp: true, redirect to auto login]")

            const originalUrl = cleanUrl(location.pathname + location.search)

            navigate(`${SIGN_IN_WITH_OTP_ROUTE}?token=${oneTimeToken}`, {
                state: { originalUrl },
            })
        } else {
            logger.info("Authenticated path but user not logged in [otp: false, redirect to login]")
            navigate(LOGIN_ROUTE)
        }
    }, [loginStatus, location, navigate])

    // NOTE: Do NOT render children if unauthenticated!
    if (loginStatus === LoginStatus.AUTHENTICATING) return null

    return (
        <>
            <IntercomProvider appId={getEnvVariable(EnvironmentVariable.INTERCOM_APPID)}>{children}</IntercomProvider>
        </>
    )
}
